import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { keywordsService } from '@/services/keywords.service';
import type { GetKeywordsParams, KeywordCreateRequest, KeywordUpdateRequest } from '@/types/keywords';

export const useKeywords = (params: GetKeywordsParams = {}) => {
  return useQuery({
    queryKey: [QUERY_KEYS.KEYWORDS, params],
    queryFn: () => keywordsService.getKeywords(params),
  });
};

export const useCreateKeywordMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: KeywordCreateRequest) => keywordsService.createKeyword(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.KEYWORDS] });
      showNotification({ title: 'Success', message: 'Keyword created successfully', color: 'green' });
    },
  });
};

export const useUpdateKeywordMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: KeywordUpdateRequest }) => keywordsService.updateKeyword(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.KEYWORDS] });
      showNotification({ title: 'Success', message: 'Keyword updated successfully', color: 'green' });
    },
  });
};

export const useDeleteKeywordMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => keywordsService.deleteKeyword(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.KEYWORDS] });
      showNotification({ title: 'Success', message: 'Keyword deleted successfully', color: 'green' });
    },
  });
};
